'use client';
import { getCurrentPosition } from '#pplx/frontend/locations/internal/utils/geolocation.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const useRequestLocation = ({ onRequest, onSuccess, onError, origin, trackEvent, }) => {
    const { $t } = useIntl();
    return useCallback(() => {
        onRequest?.();
        if (navigator.geolocation) {
            getCurrentPosition((position) => {
                onSuccess(position);
                trackEvent?.('precise location granted', { origin });
            }, (error) => {
                let errorReason;
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        onError($t({
                            description: 'Error message when device location permission is denied',
                            defaultMessage: 'Looks like permission was denied. Please allow location access in your browser site settings.',
                            id: '378de14eb2',
                        }));
                        errorReason = 'permission_denied';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        onError($t({
                            description: 'Error message when device location cannot be determined',
                            defaultMessage: 'Unable to determine your location. Please try again.',
                            id: '55cb9502cf',
                        }));
                        errorReason = 'position_unavailable';
                        break;
                    case error.TIMEOUT:
                        onError($t({
                            description: 'Error message when device location request times out',
                            defaultMessage: 'Request timed out. Please try again.',
                            id: 'c0d8e888d8',
                        }));
                        errorReason = 'timeout';
                        break;
                    default:
                        onError($t({
                            description: 'Generic error message when device location request fails',
                            defaultMessage: 'An error occurred while getting your location. Please try again.',
                            id: '083f83e002',
                        }));
                        errorReason = 'unsupported';
                }
                trackEvent?.('precise location modal denied', {
                    origin,
                    reason: errorReason,
                });
            });
        }
        else {
            onError($t({
                description: 'Error message when device location services are not supported by browser',
                defaultMessage: 'Location services are not supported by your browser.',
                id: '36613466e2',
            }));
            trackEvent?.('precise location modal denied', {
                origin,
                reason: 'unsupported',
            });
        }
    }, [$t, onError, onSuccess, onRequest, origin, trackEvent]);
};
//# sourceMappingURL=useRequestLocation.js.map